import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 33000-33999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const measurementsErrors = {
  // 33xxx is the measurements module's series. Seven of its sites needed no new code: three reused
  // MEASUREMENT_NOT_FOUND (1113) and one each FILE_VERSION_NOT_FOUND (25001, x2),
  // ESTIMATE_VERSION_NOT_FOUND (1117) and TAKEOFF_NOT_FOUND_PLAIN (26008). Two stay generic: one
  // forwards a child's message, the other interpolates saved/failed counts.
  // 33001-33007 — the measurements module's split.
  MEASUREMENT_FILTER_QUERY_NOT_FOUND: {
    errorCode: 33001,
    errorMessage: t("Filter query not found"),
    isDynamic: false,
  },
  MEASUREMENT_UNIT_NOT_CONFIGURED_ON_ESTIMATE: {
    errorCode: 33002,
    errorMessage: t("Measurement unit for this type is not configured on the estimate."),
    isDynamic: false,
  },
  // 33003/33006/33007 are the same guard on three different operations, and each names its own verb
  // ("creating" / "duplicating" / "updating"), so each keeps its own code.
  MEASUREMENT_CREATE_ACCOUNT_NOT_RESOLVED: {
    errorCode: 33003,
    errorMessage: t("The account creating this measurement could not be resolved."),
    isDynamic: false,
  },
  MEASUREMENT_PREPARE_FAILED: {
    errorCode: 33004,
    errorMessage: t("Measurement could not be prepared for this estimate version."),
    isDynamic: false,
  },
  MEASUREMENT_DUPLICATE_NOT_ALLOWED_DYNAMIC: {
    errorCode: 33005,
    errorMessage: t("Duplicate operation can't be done on Dynamic Measurements."),
    isDynamic: false,
  },
  MEASUREMENT_DUPLICATE_ACCOUNT_NOT_RESOLVED: {
    errorCode: 33006,
    errorMessage: t("The account duplicating this measurement could not be resolved."),
    isDynamic: false,
  },
  MEASUREMENT_UPDATE_ACCOUNT_NOT_RESOLVED: {
    errorCode: 33007,
    errorMessage: t("The account updating this measurement could not be resolved."),
    isDynamic: false,
  },
  MEASUREMENT_ALREADY_IN_ESTIMATE_VERSION: {
    errorCode: 33008,
    errorMessage: t("This measurement has already been added to this estimate version."),
    isDynamic: false,
  },
  MEASUREMENT_FILTER_QUERY_INVALID: {
    errorCode: 33009,
    errorMessage: t("Invalid filter query"),
    isDynamic: false,
  },
  // 33010-33011: the bulk-save summary. The nested failure sentence is dropped — its own code travels on the per-item results.
  MEASUREMENTS_PARTIAL_SAVE: {
    errorCode: 33010,
    errorMessage: t("{{saved}} of {{total}} measurements were saved. {{failed}} could not be saved."),
    isDynamic: true,
    dynamicParams: ["saved", "total", "failed"],
  },
  MEASUREMENT_SAVE_FAILED_PLAIN: {
    errorCode: 33011,
    errorMessage: t("The measurement could not be saved."),
    isDynamic: false,
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
